import * as React from 'react';
import { withRouter } from 'react-router';
import injectSheet from 'react-jss';
import { Row, Col, Icon, Tooltip, Modal, Button, message, Skeleton } from 'antd';
import moment from 'moment';
import ViewBreakdown from '../Modals/ViewBreakdown';
import { getInquiryDetailRoute, getShipmentsListRoute, getSetupMastersRoute, getCreateShipmentRoute } from 'src/routing/utils';
import ViewBidRanking from '../Modals/ViewBidRanking';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getAllInquiriesResetFilter,
  getAllInquiriesApplyFilter,
} from 'src/actions/inquiryShipperActions';
import { declineBooking, convertBookingNotesToZip } from '../../../../../src/api/booking';
import { fetchAllBookings } from 'src/actions/bookingInquiryActions';
import withAuthAccessExim from 'src/components/hoc/withAuthAccessExim';
import { INQUIRY_SHIPPER } from 'src/utils/partsToShow/partsConstants';
import { getShipmentsForBooking } from 'src/api/shipmentExecution';
import ListBidRankings from '../Modals/ListBidRankings';
import PricePerContainer from '../../../common/PricePerContainer';
import PriceTotal from '../../../common/PriceTotal';
import CommentCount from '../../../common/comments/CommentCount';
import ContainerDetails from './ContainerDetails/ContainerDetails';
import { commonStyles } from 'src/Library/CommonStyles';
import { arrayToObject } from 'src/utils/utils';
import { BookingSource, getBidTotal } from 'src/components/pages/Enquiry/InquiryUtils';
import { LinkedStatusFilter } from '../../masters/Masters.Helper';
import { EventCategories, sendEvent } from 'src/utils/gaService';
import { renderBookingOriginDetails, renderBookingDestinationDetails, commentsLocationDetails } from '../Booking/BookingUtils';
import { getEmptyContainerLocation } from './InquiryCommon';
import { InquiryModes, InquiryType } from 'src/Library/Constants';
import classNames from 'classnames';
import { fetchInquiryDetailsForShipper } from 'src/api/inquiry';
import FieldRate from 'src/components/common/form/FieldRate';
import { tokens } from 'src/design-system';

const styles = (theme: any) => ({
  iconsTheme: {
    '&:hover': {
      color: COLORS.GREEN,
    },
  },
  cardContainer: {
    height: '160px',
    marginTop: '8px',
    padding: '16px 16px 13px 16px',
    backgroundColor: tokens.colors.bgWhite,
    border: '1px solid #D9D9D9',
    borderRadius: `${tokens.radius.md}px`,
  },
  colParent: {
    borderLeft: '1px solid #E8E8E8',
    paddingLeft: '32px',
    height: '95px',
  },
  flex: {
    display: 'flex',
    flex: 1,
  },
  flexRow: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  flexCol: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    height: '85px',
  },
  bookingNum: {
    color: '#1875F0',
    fontSize: `${tokens.fontSize.h3}px`,
    fontWeight: tokens.fontWeight.semibold,
    lineHeight: '21px',
  },
  inquiryNum: {
    color: '#1875F0',
    fontSize: `${tokens.fontSize.small}px`,
    fontWeight: tokens.fontWeight.semibold,
    lineHeight: '21px',
  },
  absoluteData: {
    position: 'absolute',
    top: '24px',
  },
  internalRefNumber: {
    fontSize: `${tokens.fontSize.small}px`,
    margin: '-5px 0px 15px',
    fontWeight: tokens.fontWeight.semibold,
    width: '165px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  ffName: {
    ...commonStyles(theme).ellipses,
    display: 'block',
    fontWeight: 'bold',
  },
  connectionStatus: {
    fontSize: `${tokens.fontSize.small}px`,
  },
  status: {
    fontWeight: tokens.fontWeight.semibold,
    color: tokens.colors.textSecondary,
    marginLeft: '8px',
  },
  emptyContainerLocation: {
    color: '#666666',
    fontSize: `${tokens.fontSize.caption}px`,
    fontStyle: 'italic',
    paddingTop: '4px',
    position: 'absolute',
    left: '24px',
    bottom: '-20px',
  },
  hiddenEllipsis: {
    width: '20%',
    ...commonStyles(theme).ellipses,
  },
  portDetails: {
      display: 'flex',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      alignItems: 'center',
      maxWidth: '10ch'
  },
  portLine: {
    display: 'flex',
    alignSelf: 'center',
    margin: '0px 10px',
    width: '35%',
  }
});

const COLORS = {
  GREEN: '#52C41A',
  RED: '#F5222D',
  BLUE: tokens.colors.primary,
  GREY: '#D9D9D9',
};

class InquiryShipperCard extends React.PureComponent<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      newDeadline: null,
      declining: false,
      heading: '',
      loading: false,
      extendDeadlineModalVisible: false,
      editInquiryModalVisible: false,
      viewBreakdownVisible: false,
      viewBidsVisible: false,
      sendRFQVisible: false,
      bidRankData: null,
      isRankDataLoaded: false,
      isCancelModalVisible: false,
      shipmentDataLoading : true,
    };
  }

  async componentDidMount() {
    this.loadInitialData();
  }

  componentDidUpdate() {
    if (this.props.isLoading && !this.state.loadingData) {
      this.loadInitialData();
    }
  }

  loadInitialData = async () => {
    const { deadline, status, id : bookingId } = this.props.cardData;
    this.setState({
      isRankDataLoaded: true,
      newDeadline: deadline,
    });

    if (status === 'CONFIRMED') {
      this.setState({ shipmentDataLoading : true, loadingData: true });
      const params = { bookingId };
      // TODO add dto type
      // params: typeof ApiDto.GetShipmentsForBookingDto
      const response = await getShipmentsForBooking(params);
      this.setState({ shipmentDataLoading : false, loadingData: this.props.isLoading });
      if (response.data && response.data.length > 0) {  // todo : if exists
        this.setState({
          doShipmentsExist : true,
          shipmentId : response.data[0].id,
          loadingData: this.props.isLoading
        });
      } else {
        this.setState({ doShipmentsExist: false, loadingData: this.props.isLoading });
      }
    }
  }

  handleClickInquiryNumber = () => {
    const { inquiryId } = this.props.cardData;
    this.props.history.push(getInquiryDetailRoute('shipper', inquiryId));
  }

  handleClickBookingNumber = () => {
    const { drawerData } = this.props;
    drawerData(this.props.cardData);
  }

  handleClickViewBreakdown = () => {
    this.setState({
      viewBreakdownVisible: true,
    });
  }

  closeViewBreakdown = () => {
    this.setState({
      viewBreakdownVisible: false,
    });
  }

  handleClickViewAllBids = () => {
    this.setState({
      viewBidsVisible: true,
    });
  }

  closeViewBids = () => {
    this.setState({
      viewBidsVisible: false,
    });
  }

  renderDot = (style, char) => {
    return <div style={{
      marginBottom: '3px', height: '13px', width: '13px',
      borderRadius: `${tokens.radius.lg}px`, display: 'inline-block',
      verticalAlign: 'middle',
      ...style,
    }}><span style={{ paddingLeft: '2px' }}>{char}</span></div>;
  }

  renderLine = (color) => {
    return <div style={{ display: 'flex', flex: 1, height: '1px', backgroundColor: color }}>
    </div>;
  }

  col4Status = () => {
    const { cardData } = this.props;
    const status = cardData.status;
    const iconStyle = {
      color: '#fff',
      fontSize: '9px',
      top: '6px',
      position: 'absolute',
    } as React.CSSProperties;

    let backgroundColor;
    let statusValue;
    let char;
    switch (status) {
      case 'OPEN': {
        backgroundColor = COLORS.BLUE;
        statusValue = 'Booking Requested';
        break;
      }
      case 'CONFIRMED': {
        backgroundColor = COLORS.GREEN;
        statusValue = 'Booked';
        char = <Icon style={iconStyle} type="check" />;
        break;
      }
      case 'CANCELLED': {
        backgroundColor = COLORS.RED;
        statusValue = 'Cancelled';
        break;
      }
      case 'DECLINED': {
        backgroundColor = COLORS.RED;
        statusValue = 'Declined';
        char = <Icon style={iconStyle} type="close" />;
        break;
      }
      default: {
        backgroundColor = COLORS.BLUE;
        statusValue = 'Booking Requested';
        break;
      }
    }
    return (
      <div style={{
        fontWeight: tokens.fontWeight.semibold, fontSize: `${tokens.fontSize.body}px`, color: '#252323d9',
      }}>
        {this.renderDot({
          backgroundColor,
          marginRight: '11px',
          marginLeft: '3px',
          verticalAlign: 'middle',
        }, char ? char : '')}
        <span>{statusValue}</span>
      </div>)
      ;
  }

  getStatusDate = () => {
    const { cardData: data } = this.props;
    const statusDate = `${moment(data.statusDate).format('DD MMMM, YYYY | HH:mm')}Hrs`;
    const statusDateString = statusDate;
    const statusDateColor = '#424242';

    if (!statusDate) return;

    return <div style={{ fontSize: '11px', color: `${statusDateColor}`, paddingLeft: '26px' }}>
      <span>{statusDateString}</span>
    </div>;
  }

  renderDataCol1 = () => {
      const { classes, cardData: data } = this.props;
      return <div className={classes.flexCol}>
        <div style={{ marginBottom: '8px' }}>
          <a className={classes.bookingNum}
            onClick={this.handleClickBookingNumber}>{data.bookingNumber}</a>
        </div>
        <div style={{ bottom: '0' }}>
          {data.internalReferenceNumber ?
            <Tooltip title={data.internalReferenceNumber}>
              <div className={classes.internalRefNumber}>
                <span style={{ fontWeight:500, color: '#A7A7A7' }}>Internal # </span>
                {data.internalReferenceNumber}
              </div>
            </Tooltip> :
            null}
          {data.source !== BookingSource.DIRECT_BOOKING &&
            <React.Fragment>
              <Row>
                <div style={{ fontSize: `${tokens.fontSize.small}px` }}>Inquiry</div>
              </Row>
              <Row>
                <a className={classes.inquiryNum}
                  onClick={this.handleClickInquiryNumber}>{data.inquiryReferenceNumber}</a>
              </Row>
            </React.Fragment>
          }
          {data.creationUser &&
            <Row style={{ marginTop: '8px', display: 'flex', alignItems: 'center', fontSize: '11px', color: '#666' }}>
              <Icon type="user" style={{ marginRight: '6px' }} />
              <span>{data.creationUser}</span>
            </Row>
          }
        </div>
      </div>;
    }

  getContainerType(key) {
    const { containerTypes } = this.props;
    if (!key || !containerTypes) return;
    const type = containerTypes.filter(item => item.key === key);
    if (type.length > 0) return type[0].label;
  }

  renderDataCol2 = () => {
    const { classes, cardData: data } = this.props;
    return (
      <div style={{ width: '100%' }}>
        <div className={classes.flexRow} style={{
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '25px', marginTop: '4px',
          marginRight: '110px',
        }}>
          <div>
            {this.renderDot({ backgroundColor: COLORS.GREY }, '')}
            <div className={classNames(classes.absoluteData, classes.hiddenEllipsis)} style={{
              left: '22px',
            }}>
            {renderBookingOriginDetails(data, classes)}
            </div>
          </div>
          {this.renderLine(COLORS.GREY)}
          <ContainerDetails data={data} />
          {this.renderLine(COLORS.GREY)}
          <div>
            {this.renderDot({ border: `1px solid ${COLORS.GREY}` }, '')}
            <br />
            <div 
            className={classNames(classes.absoluteData, classes.hiddenEllipsis)}
            style={{
              minHeight: '50%',
            }}
            >
              {renderBookingDestinationDetails(data, classes)}
            </div>
          </div>
        </div>
        <div className={classes.emptyContainerLocation}>
          {data.inquiryMode === InquiryModes.TRAILER &&
            data.emptyContainerLocationPortDetails?.code !== data.destinationPortDetails?.code &&
            getEmptyContainerLocation(data.inquiryType, data.emptyContainerLocationPortDetails?.name)}
        </div>
      </div>
    );
  }

  renderDataCol3 = () => {
    const { classes, cardData, permissions: { INQUIRY_VIEW_BIDS_ACTIONS }, vendorRating } = this.props;
    const bidRankData = cardData.bidDetails;
    const roadModes = [InquiryModes.DOMESTIC, InquiryModes.RPTL];
    const enablePricePerContainer = !roadModes.includes(cardData.inquiryMode);
    const vendorRated = cardData?.ffRating || 0;
    const vendorRatedLabel = vendorRated ? vendorRating[vendorRated - 1] : ''
    return (
      !INQUIRY_VIEW_BIDS_ACTIONS 
      ? <>
        <div style={{ textAlign: 'center', width: '90%' }} >
          <Skeleton title={false} paragraph={{ rows: 3 }} />
        </div>
      </>
      : <>
        <Col span={24}>
          <Row>
            <div style={{ fontSize: `${tokens.fontSize.small}px` }}>
              Final Cost
            </div>
          </Row>
          <Row>
            <Col span={12} >
              <div style={{ fontSize: `${tokens.fontSize.h2}px`, color: 'black' }}>
                {enablePricePerContainer ? '' : this.props.currencySymbols[`${bidRankData.finalPrice.currency}`]}
                {enablePricePerContainer ? <PricePerContainer
                  amount={bidRankData.totalPerUnit && bidRankData.totalPerUnit.amount}
                  currency={bidRankData.totalPerUnit && bidRankData.totalPerUnit.currency}
                  containerTypes={bidRankData.totalPerUnitType}
                  perLabel={bidRankData.totalPerUnit && bidRankData.totalPerUnit.format}
                  mode={cardData.inquiryMode}
                  freightPerUnit={bidRankData.freightPerUnit}
                  sourceObjectType={'BOOKING'} /> : `${getBidTotal(bidRankData.finalPrice.amount)} `}
                { (cardData.status === 'CONFIRMED' || cardData.status === 'OPEN') && cardData.source !== BookingSource.DIRECT_BOOKING ?
                <span style={{ fontSize: '11px', color: '#242222' }}>
                    | Rank {bidRankData.rank}</span> : null
                }
                {
                  bidRankData.bookingRemarks ? <span>
                    <Tooltip title={<div>
                      <div>Reasons for selecting L{bidRankData.rank}:</div>
                      <div>{bidRankData.bookingRemarks}</div>
                    </div>}>
                      <Icon type="info-circle" theme="filled"
                      style={{ color: '#595959', marginLeft: '2px', fontSize: `${tokens.fontSize.caption}px` }} />
                    </Tooltip>
                  </span> : null
                }
              </div>
            </Col>
            <Col span={12} >
              <div style={{
                height: '40px', width: '100px',
                backgroundImage: `url("${bidRankData.shippingLineLogoUrl}")`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                backgroundPosition: 'center' }}></div>
            </Col>
          </Row>
          <Row>
            <Tooltip title={cardData.ffName} placement="topLeft">
              <span className={classes.ffName}>{cardData.ffName}</span>
            </Tooltip>
            <FieldRate
              isView={true}
              isFlex={true}
              styles={{ fontSize: `${tokens.fontSize.caption}px` }}
              disabled={true}
              value={vendorRated}
              ratingViewLabel={vendorRatedLabel}
              maxChars={24}
              labelStyles={{fontWeight: 500, fontSize: `${tokens.fontSize.small}px`, fontStyle: 'italic'}}
            />
          </Row>
          <Row>
            <div style={{ padding: '0px 0px' }}>
              <Col style={{ margin: '11px 0px 18px' }} span={12}>
                <>
                  <a style={{ fontSize: `${tokens.fontSize.small}px`, color: tokens.colors.primary, margin: '15px 0px 0px 0px' }}
                    onClick={this.handleClickViewBreakdown}>
                    View Breakdown</a>
                  {this.state.viewBreakdownVisible && <ViewBreakdown
                    mode={cardData?.mode}
                    type={'SHIPPER'}
                    bookingIdCard={cardData.id}
                    bidId={cardData.bidDetails.id}
                    inquiryId={cardData.inquiryId}
                    visible={this.state.viewBreakdownVisible}
                    handleCancel={this.closeViewBreakdown}
                    handleOk={this.closeViewBreakdown} 
                    source={'BOOKING'}/>}
                </>
              </Col>
              <Col style={{ margin: '11px 0px 18px' }} span={12}>
                <>
                  <a style={{ fontSize: `${tokens.fontSize.small}px`, color: tokens.colors.primary, margin: '15px 0px 0px 0px' }}
                    onClick={this.handleClickViewAllBids}>
                    View All Bids</a>
                  {this.state.viewBidsVisible && <ListBidRankings
                    mode={cardData.inquiryMode}
                    bookingSource={cardData.source}
                    bookingId={cardData.id}
                    shipperId={cardData.shipperId}
                    visible={this.state.viewBidsVisible}
                    handleCancel={this.closeViewBids}
                    handleOk={this.closeViewBids} />}
                </>
              </Col>
            </div>
          </Row>
        </Col>
      </>
    );
  }

  showCancelConfirmationModal = (isTrue) => {
    this.setState({
      isCancelModalVisible: isTrue,
    });
  }

  handleBookingCancel = async () => {
    const { cardData } = this.props;
    this.setState({ declining: true });
    const response = await declineBooking({
      bookingId: cardData.id,
    });
    if (response.isSuccess) {
      sendEvent(
        EventCategories.INQUIRY_BOOKING_SHIPPER,
        'Cancel booking? - yes',
      );
      this.showCancelConfirmationModal(false);
      this.props.fetchAllBookings('SHIPPER');
    }
    this.setState({ declining: false });
  }

  onStartShipment = async () => {
    const { history, cardData } = this.props;
    sendEvent(
      EventCategories.INQUIRY_BOOKING_SHIPPER,
      'Start Shipment - Clicked',
    );
    const inquiryDataResponse = await fetchInquiryDetailsForShipper({ inquiryId: cardData.inquiryId });
    if (inquiryDataResponse?.isSuccess && inquiryDataResponse?.data && inquiryDataResponse?.data?.id) {
      const createShipmentData = {
        ...cardData,
        teamDetails: [{teamId: inquiryDataResponse.data.accessorId , teamName: inquiryDataResponse.data.accessorName}],
        accessType: inquiryDataResponse.data.accessorType,
      }
      history.push(getCreateShipmentRoute(), {
        createShipment: true,
        data: createShipmentData,
        disableBooking: true,
        fromBooking: true,
        sourceObjectId: cardData?.id,
        sourceObjectType: 'BOOKING',
      });
    } else {
      message.error(`Error:
        ${inquiryDataResponse.errorMessage ? inquiryDataResponse.errorMessage : 'Something went wrong. Please try again'}
      `);
      return;
    }
  }

  viewShipment = () => {
    const { history } = this.props;
    const { shipmentId } = this.state;
    history.push(getShipmentsListRoute('shipper'), { shipmentId, activeTab: 'details' });
  }

  renderCommentModalHeader = () => {
    const { cardData, classes } = this.props;
    const bidRankData = cardData.bidDetails;
    const roadModes = [InquiryModes.DOMESTIC, InquiryModes.RPTL];
    const isDomesticMode = roadModes.includes(cardData.inquiryMode);
    return (
      <Row style={{ display: 'flex', paddingLeft: '15px', width: '100%' }} gutter={10}>
        <Col span={4} style={{ display: 'flex', borderRight: '1px solid #E8E8E8' }}>
          <a
            className={classes.bookingNum}
            style={{ alignSelf: 'center', color: '#000' }}
            onClick={this.handleClickBookingNumber}
          >
            {cardData.bookingNumber}
          </a>
        </Col>

        <Col
          span={10}
          style={{
            display: 'flex',
            borderRight: '1px solid #E8E8E8',
            justifyContent: 'center',
          }}
        >
          <div
            className={classes.portDetails}
          >
            {commentsLocationDetails(cardData, 'ORIGIN')}
          </div>

          <div
            className={classes.portLine}
          >
            {this.renderDot({ backgroundColor: COLORS.GREY }, '')}
            <div
              style={{
                marginTop: '6px',
                width: '100%',
              }}
            >
              {this.renderLine(COLORS.GREY)}
            </div>
            {this.renderDot({ border: `1px solid ${COLORS.GREY}` }, '')}
          </div>

          <div
            className={classes.portDetails}
          >
            {commentsLocationDetails(cardData, 'DESTINATION')}
          </div>
        </Col>

        <Col span={10} style={{ display: 'flex', marginLeft: '30px' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignSelf: 'center',
              marginRight: '30px',
            }}
          >
            <div>
              <PriceTotal
                commentTextStyle={true}
                amount={bidRankData.finalPrice.amount}
                currencySymbol={this.props.currencySymbols[`${bidRankData.finalPrice.currency}`]}
              />
              {isDomesticMode ? '' : <PricePerContainer
                commentTextStyle={true}
                amount={bidRankData.totalPerUnit && bidRankData.totalPerUnit.amount}
                currency={bidRankData.totalPerUnit && bidRankData.totalPerUnit.currency}
                containerTypes={bidRankData.totalPerUnitType}
                mode={cardData.inquiryMode}
                sourceObjectType={'BOOKING'}
              />}
            </div>
          </div>

          <div style={{ height: '40px', marginRight: '30px' }}>
            <img src={bidRankData.shippingLineLogoUrl} />
          </div>

          <div
            style={{
              fontSize: `${tokens.fontSize.body}px`,
              color: '#262626',
              alignSelf: 'center',
            }}
          >
            {cardData.shipperName}
          </div>
        </Col>
      </Row>
    );
  }

  isBookedFromSportSearch = () => {
    const { cardData } = this.props;
    const { source } = cardData;
    return source === BookingSource.SPOT_BOOKING || source === BookingSource.DIRECT_BOOKING;
  }

  renderDataCol4 = () => {
    const { show_shipment_execution_shipper } = this.props.modules;
    const { classes, cardData, permissions: { INQUIRY_ALL_ACTIONS }, organisationOnboardingStatusMap,
      history } = this.props;
    const { shipmentDataLoading, isCancelModalVisible, doShipmentsExist } = this.state;
    const { connectionStatus } = cardData;
    const enableBookingNoteDownload = cardData.status === 'CONFIRMED' && 
      cardData?.confirmationDetails?.documents?.length &&
      cardData?.confirmationDetails?.documents?.filter((item) => item.type === 'DO')?.length;
    return (
      <div style={{ width: '100%' }}>
        <Col span={24}>
          <Row style={{ display: 'flex' }}>
            <Col span={19} style={{ fontSize: `${tokens.fontSize.small}px`, display: 'inline' }}>Status</Col>
              <Col span={5} style={{ marginBottom: '-14px' }}>
              {!this.props.isParentOrg && (
                <CommentCount
                  prefetchedCount={cardData.commentCount}
                  isLoading={this.props.isLoading}
                  commentApiPrefix={'booking'}
                  style={{
                    float: 'right',
                  }}
                  sourceObjectId={cardData.id}
                  modalHeader={this.renderCommentModalHeader()} />
                )}
              </Col>
          </Row>
          <Row>{this.col4Status()}</Row>
          <Row>{this.getStatusDate()}</Row>

          <Row>
            <Col style={{ margin: '11px 0px 18px', display: 'flex',
              flexDirection: 'column' }} span={8}>
              {INQUIRY_ALL_ACTIONS && (cardData.status === 'OPEN' || cardData.status === 'CONFIRMED') ?
                <a style={{ fontSize: `${tokens.fontSize.small}px`, color: '#F5222D' }}
                  onClick={() => this.showCancelConfirmationModal(true)}>
                  Cancel</a> :
                null
              }
              {enableBookingNoteDownload ?
                <a style={{ fontSize: `${tokens.fontSize.small}px`, color: tokens.colors.primary }}
                  onClick={()=>convertBookingNotesToZip(cardData)}>
                  <Icon style={{ paddingRight: '4px', fontSize: `${tokens.fontSize.body}px` }} type="download" />
                  {cardData.inquiryMode === InquiryModes.TRAILER &&
                  cardData.inquiryType === InquiryType.IMPORT ? 'DO' : 'Booking Note'}</a> :
                null
              }
            </Col>
            {INQUIRY_ALL_ACTIONS && cardData.status === 'CONFIRMED' && ![InquiryModes.TRAILER].includes(cardData.inquiryMode)  &&
            <Col style={{ textAlign: 'right' }} span={16}>
              {shipmentDataLoading ? null
               : (doShipmentsExist ?
                <div style={{ marginTop: '12px' }}>
                  <div style={{	color: tokens.colors.textSecondary,	fontFamily: 'Open Sans',
                    fontSize: `${tokens.fontSize.small}px`,	fontWeight: tokens.fontWeight.semibold, lineHeight: '12px',
                    marginBottom: '8px' }}>Execution Started</div>
                  <div style={{	color: tokens.colors.primary,	fontFamily: 'Open Sans',
                    fontSize: `${tokens.fontSize.small}px`,	fontWeight: tokens.fontWeight.semibold, lineHeight: '12px',
                    cursor: 'pointer' }}
                    onClick={this.viewShipment}>View Shipment</div>
                </div>
                : (show_shipment_execution_shipper ?
                <Button type="primary" size="small"
                  onClick={this.onStartShipment}
                  style={{
                    backgroundColor: tokens.colors.primary,
                    fontSize: `${tokens.fontSize.caption}px`,
                    border: tokens.colors.primary, marginTop: '17px',
                  }}>
                  <span style={{ lineHeight: '18px' }}>
                  Start Shipment</span>
                </Button> : null)
               )}
            </Col>}
            <Modal
              title="Booking Cancellation"
              visible={isCancelModalVisible}
              confirmLoading={this.state.declining}
              onOk={this.handleBookingCancel}
              onCancel={() => {
                sendEvent(
                  EventCategories.INQUIRY_BOOKING_SHIPPER,
                  'Cancel booking? - no',
                );
                this.showCancelConfirmationModal(false);
              }}
            >Are you sure you want to cancel the booking ?</Modal>
          </Row>
          {this.isBookedFromSportSearch() && cardData.status === 'OPEN' &&
            connectionStatus !== LinkedStatusFilter.LINKED &&
            <Row className={classes.connectionStatus}>
              <Col span={16} style={{ marginTop: '-14px' }}>
                <span style={{ fontStyle: 'italic', color: '#666666' }}>
                  Connection Status
                </span>
                <span className={classes.status}>
                  {connectionStatus ? organisationOnboardingStatusMap[connectionStatus].label : ''}
                </span>
              </Col>
              <Col span={8} style={{ marginTop: '-14px' }}>
                <a style={{ color: tokens.colors.primary, float: 'right' }}
                  onClick={() => history.push(getSetupMastersRoute('VENDOR'), connectionStatus)}>
                  View Masters
                </a>
              </Col>
            </Row>}
        </Col>
      </div>
    );
  }

  renderColumn = (span, elem, renderBorder = true, paddingLeft = '32px') => {
    const { classes } = this.props;
    return <Col span={span} style={{ display: 'flex', flex: 1, paddingLeft }}
      className={renderBorder ? classes.colParent : undefined}>
      {elem}
    </Col>;
  }

  render() {
    const { cardData: data, classes, cardData: { id: bookingId, bookingNumber } } = this.props;
    return (
      <div style={
        ((data.status === 'CONFIRMED') ? { border: `1px solid ${COLORS.GREEN}` } : undefined)}
        className={classes.cardContainer}>
        <Row >
          {this.renderColumn(3, this.renderDataCol1(), false, '0px')}
          {this.renderColumn(9, this.renderDataCol2())}
          {this.renderColumn(6, this.renderDataCol3())}
          {this.renderColumn(6, this.renderDataCol4(), true, '12px')}
        </Row>
      </div>);
  }
}

const mapStateToProps = ({ masterData, staticData }) => ({
  currencySymbols: masterData.currencySymbols,
  containerTypes: staticData.containerTypesKeyVal,
  permissions: masterData.permissions,
  modules: masterData.modules,
  organisationOnboardingStatusMap: arrayToObject(masterData.organisationOnboardingStatusMaster, 'key'),
  vendorRating: Object.values(masterData?.vendorRating?.mapping || {}),
  isParentOrg: masterData.isParentOrg,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  getAllInquiriesResetFilter,
  getAllInquiriesApplyFilter,
  fetchAllBookings,
}, dispatch));

const InquiryShipperCardStyled = injectSheet(styles)(InquiryShipperCard);
export default withRouter(connect(mapStateToProps,
  mapDispatchToProps)(withAuthAccessExim([INQUIRY_SHIPPER])(InquiryShipperCardStyled)));
